import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "../UI/alert-dialog";
import { cn } from "../../Lib/Cn";

export function AlertBox({
  open,
  onOpenChange,
  title = "Alert",
  description = "",
  content = null, // ✅ new: JSX/HTML content
  actions = [],
  onAction = () => { },
  className = "",
  mobileRow = false,
  mobileStack = false,
  hideFooterBorder = false,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        className={cn(
          "w-[90%] sahi-radius p-4 shadow-lg flex flex-col max-h-[85vh] max-h-[85dvh] overflow-hidden",
          className
        )}
      >
        <AlertDialogHeader className="text-left flex-1 overflow-y-auto min-h-0 space-y-2 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <AlertDialogTitle className="text-lg font-semibold shrink-0">
            {title}
          </AlertDialogTitle>

          {/* ✅ description (string) */}
          {description && (
            <AlertDialogDescription className="text-sm text-gray-600 mt-1 shrink-0">
              {description}
            </AlertDialogDescription>
          )}

          {/* ✅ extra content (JSX/HTML) */}
          {content && (
            <div className="text-sm text-gray-700">{content}</div>
          )}
        </AlertDialogHeader>

        {/* Desktop Layout */}
        {actions.length > 0 && (
          <AlertDialogFooter className={cn("hidden sm:flex sm:flex-row-reverse gap-2 shrink-0 pt-2", !hideFooterBorder && "border-t border-gray-100", "sm:border-t-0")}>
            {actions.map((action, index) => {
              const ButtonComponent =
                action.variant === "cancel"
                  ? AlertDialogCancel
                  : AlertDialogAction;

              return (
                <ButtonComponent
                  key={index}
                  className={cn("px-4 py-2 rounded-md", action.className)}
                  onClick={() => {
                    onAction(action.value);
                    onOpenChange(false);
                  }}
                >
                  {action.icon && <span >{action.icon}</span>}
                  {action.label}
                </ButtonComponent>
              );
            })}
          </AlertDialogFooter>
        )}

        {/* Mobile Layout */}
        {actions.length > 0 && (
          <AlertDialogFooter className={cn("flex sm:hidden gap-2 w-full shrink-0 pt-2", !hideFooterBorder && "border-t border-gray-100", "sm:border-t-0", mobileStack ? "flex-col" : mobileRow ? "flex-row" : "flex-row flex-wrap")}>
            {actions
              .slice()
              .reverse()
              .map((action, index) => {
                const ButtonComponent =
                  action.variant === "cancel"
                    ? AlertDialogCancel
                    : AlertDialogAction;

                // In the default (non-mobileRow, non-mobileStack) layout, non-cancel actions
                // share a row (e.g. "Yes, Add Record" / "No, Just Complete") while the cancel
                // action is forced onto its own full-width line below them. mobileStack puts
                // every action on its own row.
                const widthClass = mobileStack
                  ? "w-full"
                  : mobileRow
                    ? "flex-1"
                    : (action.variant === "cancel" ? "w-full" : "flex-1 basis-0 min-w-0");

                return (
                  <ButtonComponent
                    key={index}
                    className={cn(
                      widthClass,
                      "px-4 py-3 rounded-md text-sm font-medium flex items-center justify-center gap-2",
                      action.className
                    )}
                    onClick={() => {
                      onAction(action.value);
                      onOpenChange(false);
                    }}
                  >
                    {action.icon && <span>{action.icon}</span>}
                    {action.label}
                  </ButtonComponent>
                );
              })}
          </AlertDialogFooter>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
}